import Header from '../utill/Header'
import Footer from '../utill/Footer'
import Sidebar from '../utill/Sidebar'
import {Button, Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {RootState} from "../../redux/store";
import StyledTableCell from "../utill/StyledTableCell"

interface Popup {
    id: string;
    title: string;
    content: string;
    bold: string;
    cancelable: number;
    displayOnce: number;
    minSdkVersion: string;
    maxSdkVersion: string;
    appVersion: string;
    os: string;
    registerDtm: string;
}

function PopupManagement() {
    const url = useContext(Url)
    const [data, setData] = useState<Popup[]>([]);
    const [totalData, setTotalData] = useState();
    const [searchText, setSearchText] = useState('');
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.user.value);
    let userId = user.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-팝업 관리'
        if (auth.MENUAUTH?.POP0000?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        setWriteAuthorityYn(auth.MENUAUTH?.POP0000?.writeAuthorityYn === "1");
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'popup/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setData(response.data.result.data)
                setTotalData(response.data.result.totalData)
            })
        })
    }, []);

    const handleSubmit = async () => {
        await reissue(userId, url, navigate);

        if (searchText === '0' || searchText === "") {
            axios.get(url + 'popup/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setData(response.data.result.data);
                setTotalData(response.data.result.totalData);
            });
        } else {
            axios.get(url + 'popup/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: { value: searchText }
            }).then((response) => {
                setData(response.data.result.data);
                setTotalData(response.data.result.totalData);
            });
        }
    };

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // 숫자만 입력 가능하도록 검사
        if (!/^\d*$/.test(value)) {
            alert('숫자만 입력 가능합니다.');
            return;
        }

        setSearchText(value);
    }

    const handleAddClick = () => {
        navigate('/PopupAdd');
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
            handleSubmit();
        }
    }

    const boldText = (text: string, highlight: string) => {
        if (!highlight) return text; // 강조할 부분이 없으면 원본 텍스트 반환
        const parts = text.split(new RegExp(`(${highlight})`, 'gi')); // 강조할 부분을 기준으로 나눕니다.
        return parts.map((part, index) =>
            part.toLowerCase() === highlight.toLowerCase() ? (
                <strong key={index} style={{fontWeight:"bold"}}>{part}</strong> // 강조할 부분을 bold 처리합니다.
            ) : (
                part // 원본 텍스트는 그대로 반환합니다.
            )
        );
    };

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"POP0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='팝업 관리'/>
                        <p className="header-message">팝업을 관리합니다. 원하는 팝업을 클릭하면 수정 페이지로 이동합니다.</p>
                        <br/>
                        <Card className="card shadow mb-4">
                            <Card.Header className="py-3">
                                <Form id="searchForm">
                                    <div className='form-group row'>
                                        <div className='search_area'>
                                            <Form.Control type="text" placeholder="SDK 버전" onKeyDown={handleKeyDown}
                                                          value={searchText} onChange={handleSearch}/>
                                        </div>
                                        <div className='search_button_area'>
                                            <Button variant="primary" className='search_button'
                                                    onClick={handleSubmit}>검색</Button>
                                        {writeAuthorityYn &&
                                            <Button className="search_button" style={{marginLeft:'1rem'}}
                                                    onClick={handleAddClick}>팝업 등록</Button>
                                        }
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <div style={{display: 'flex'}}>
                                    <p className='card-body_content'>검색 결과 : 총 {totalData}건</p>
                                </div>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center" style={{width:"10rem"}}>제목</StyledTableCell>
                                                <StyledTableCell align="center" style={{width:"25rem"}}>내용</StyledTableCell>
                                                <StyledTableCell align="center" style={{width:"10rem"}}>Bold 내용</StyledTableCell>
                                                <StyledTableCell align="center" style={{width:"6.2rem"}}>취소버튼 여부</StyledTableCell>
                                                <StyledTableCell align="center">표출 횟수</StyledTableCell>
                                                <StyledTableCell align="center">최소 SDK 버전</StyledTableCell>
                                                <StyledTableCell align="center">최대 SDK 버전</StyledTableCell>
                                                <StyledTableCell align="center">Mcon 버전</StyledTableCell>
                                                <StyledTableCell align="center" style={{width:"10rem"}}>OS</StyledTableCell>
                                                <StyledTableCell align="center">등록일시</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {writeAuthorityYn ? (<TableBody>
                                            {data.map(popup => (
                                                <TableRow component={Link} to='/PopupModify' key={popup.id} className="custom-link" state={{
                                                    id: popup.id,
                                                }} sx={{
                                                    '&:hover td': {
                                                        backgroundColor: 'rgba(0,111,255,0.13)'
                                                    },
                                                    '&:active td': {
                                                        backgroundColor: 'rgba(0,149,255,0.13)'
                                                    }
                                                }}>
                                                    <StyledTableCell align="center">{popup.title || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center" className="popupTable">{boldText(popup.content, popup.bold) || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center"><p style={{fontWeight:"bold"}}>{popup.bold || "-"}</p></StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {popup.cancelable === 0 ? 'N' : popup.cancelable === 1 ? 'Y' : ''}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {popup.displayOnce === 0 ? '항상' : popup.displayOnce === 1 ? '1회' : ''}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">{popup.minSdkVersion || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.maxSdkVersion || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.appVersion || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.os || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.registerDtm.replace('T', ' ')}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>):(<TableBody>
                                            {data.map(popup => (
                                                <TableRow key={popup.id} className="custom-link"
                                                          sx={{
                                                              '&:hover td': {
                                                                  backgroundColor: 'rgba(0,111,255,0.13)'
                                                              },
                                                              '&:active td': {
                                                                  backgroundColor: 'rgba(0,149,255,0.13)'
                                                              }
                                                          }}>
                                                    <StyledTableCell align="center">{popup.title || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{boldText(popup.content, popup.bold) || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center"><p style={{fontWeight:"bold"}}>{popup.bold || "-"}</p></StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {popup.cancelable === 0 ? 'N' : popup.cancelable === 1 ? 'Y' : ''}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        {popup.displayOnce === 0 ? '항상' : popup.displayOnce === 1 ? '1회' : ''}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="center">{popup.minSdkVersion || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.maxSdkVersion || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.appVersion || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.os || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{popup.registerDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>)}
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default PopupManagement;